import * as React from "react";
import { Button } from "reactstrap";
import {IFindJobComponentPropsData, IFindJobComponentPropsFunctions} from "./IFindJobComponentProps";

type IProps = IFindJobComponentPropsData & IFindJobComponentPropsFunctions & {history: any};
type IState = {jobId: string};

class FindJobComponent extends React.PureComponent<IProps, IState> {
    
    state = {
        jobId: "",
    };
    
    handleChange = evt => {
        this.setState({jobId: evt.target.value});
    };
    
    handleSubmit = evt => {
        evt.preventDefault();
        this.props.handleSubmit(this.state.jobId, this.props.history);
    };
    
    render() {
        return <form className="ll-find-job form-inline" onSubmit={this.handleSubmit}>
            <span>Job ID:</span>
            <input type="search" placeholder="e.g. xxxxxx" className="form-control"
                value={this.state.jobId}
                onChange={this.handleChange}
            />
            <Button type="submit">Find job</Button>
        </form>
    }
    
}

export default FindJobComponent;
